import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n"; // Initialize i18n
import App from "./App";

// Global error handler to capture and log errors from cross-origin scripts
// These errors appear as "Script error" because browsers hide details for security
window.onerror = function(message, _source, _lineno, _colno, _error) {
  // Ignore cross-origin script errors (they show as "Script error.")
  // These come from: PostHog, rrweb, emergent-main.js, etc.
  if (message === 'Script error.' || message === 'Script error') {
    // Silently ignore - this is expected from third-party scripts
    return true; // Prevents the error from appearing in console
  }
  
  // Log real application errors (silently handled)
  return false; // Let other handlers process the error
};

// Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  // Ignore rejections from third-party scripts
  const reason = event.reason;
  if (reason?.message?.includes('posthog') || 
      reason?.message?.includes('rrweb') ||
      reason?.message?.includes('Script error')) {
    event.preventDefault();
    return;
  }
});

// Suppress error overlay in development for cross-origin errors
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  console.error = (...args) => {
    // Filter out cross-origin script errors
    if (args[0]?.includes?.('Script error') || 
        args[0]?.toString?.().includes?.('Script error')) {
      return;
    }
    originalError.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
